export default __webpack_public_path__ + "static/media/edit.1fba010f.svg";